var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMortgage105 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 105,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M43.996 37.996h17v17h-17v-17Zm1 1v15h15v-15h-15Zm-3 31h21v24h23v-42h1v43h-69v-43h1v42h23v-24Zm1 24h19v-23h-19v23Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M96.813 46.11 52.496 9.85l-29.5 24.137v-15.49h-1v16.308L8.18 46.109l.633.774 43.683-35.74 43.684 35.74.633-.774Z",
  clipRule: "evenodd"
})));
export { SvgMortgage105 as ReactComponent };
export default __webpack_public_path__ + "39df2b73976d19d27baf30392c20b213.svg";